module.exports = __webpack_public_path__ + "static/media/10_hero_tablet.9b572ed3.jpg";